import React, { Component } from 'react';
import ModalModule from '../modal';
import UI from '../ui';
import Utils from '../utils';

const { ModalButtonActionType } = ModalModule;
const { WrappedInputTextWithLabel, Spinner, WrappedButton, WrappedButtonType } =
	UI;
const { Communication, withLayoutAndModalContexts } = Utils;

class ForgotUsername extends Component {
	constructor(props) {
		super(props);

		this.state = {
			emailAddress: '',
			errorMessage: '',
			emailAddressError: 0,
			showSuccess: false,
			clean: true,
			mask: false,
		};
	}

	handleInputChange = e => {
		this.setState({
			[e.target.name]: e.target.value,
			clean: false,
		});
	};

	onKeyPressEnter = e => {
		const {
			key,
			target: { value },
		} = e;

		if (key === 'Enter' && value !== '') {
			e.preventDefault();

			this.onContinueButtonClick();
		}
	};

	onInputTextBlur = e => {
		const { value } = e.target;
		const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
		let errorMessage = '';

		if (value === '') {
			errorMessage = 'This field is required';
		} else if (emailRegex.test(value) === false) {
			errorMessage = 'This is not a valid email address';
		}

		this.setState({
			emailAddressError: value !== '' && emailRegex.test(value) ? 1 : -1,
			errorMessage,
		});
	};

	onUserChangeSuccess = () => {
		// redirect to Auth 0 login page
		const { goToSignInView } = this.props;
		goToSignInView();
	};

	onContinueButtonClick = async () => {
		const {
			modalContext: { showError },
		} = this.props;
		const { emailAddress, emailAddressError } = this.state;

		if (emailAddressError === 1) {
			this.setState({ mask: true });

			const recoverUsernameResponse = await Communication.recoverUsername({
				EmailAddress: emailAddress,
			});

			if (Communication.isSuccessful(recoverUsernameResponse)) {
				this.setState({
					mask: false,
					showSuccess: true,
				});
			} else {
				showError({
					data: {
						title: 'Error',
						description: recoverUsernameResponse.ErrorDescription,
						primaryButtonType: ModalButtonActionType.Ok,
						primaryButtonText: 'OK',
						handleType: 'custom',
					},
				});
			}
		}
	};

	goToSignInView = () => {
		const { goToSignInView } = this.props;
		goToSignInView();
	};

	render() {
		const { modalId, layoutContext } = this.props;
		const {
			emailAddress,
			errorMessage,
			emailAddressError,
			showSuccess,
			clean,
			mask,
		} = this.state;

		const forgotUsernameButton = {
			type: ModalButtonActionType.Ok,
			text: 'Continue',
			onClick: this.onContinueButtonClick,
			disabled: clean,
			dataqa: 'forgot-username-continue-button',
		};

		const successMessageButton = {
			type: ModalButtonActionType.Ok,
			text: 'Ok',
			onClick: this.closeResetPasswordModal,
			dataqa: 'forgot-username-ok-button',
		};

		const { isMobile } = layoutContext;

		return (
			<>
				{showSuccess ? (
					<div className="common-authentication auth-forgot-username-view success-message-view">
						<div className="form">
							<div className="primary-header">Check Your Email</div>
							<p className="content">
								If the email address entered matches the one associated with
								your account, we will send your username to that email address.
							</p>
							<p className="content">
								Check your spam folder if you cannot find the email after a few
								minutes.
							</p>
							<div className="row-container centered">
								<WrappedButton
									label="Return to login"
									onClick={this.goToSignInView}
									buttonType={WrappedButtonType.goToSignInView}
									dataqa="return-to-login"
								/>
							</div>
						</div>
					</div>
				) : (
					<div className="common-authentication auth-forgot-username-view">
						<div className="form">
							<div className="primary-header">Forgot Username</div>
							<p className="content">
								Enter the email address you used to create your account.
							</p>
							<div className="row-container">
								<WrappedInputTextWithLabel
									showErrorBelow
									isInputInvalid={emailAddressError === -1}
									errorMessage={errorMessage}
									className="inputtext"
									label="Email address:"
									uiElementConfig={{
										type: 'text',
										value: emailAddress,
										name: 'emailAddress',
										onChange: this.handleInputChange,
										onBlur: this.onInputTextBlur,
										onKeyPress: this.onKeyPressEnter,
										required: true,
										dataqa: 'forgotusernameemailaddress',
										autoFocus: true,
									}}
								/>
							</div>

							{mask && <Spinner msg="Verifying email address..." />}
							<div className="row-container centered">
								<WrappedButton
									label="Continue"
									onClick={this.onContinueButtonClick}
									buttonType={WrappedButtonType.Primary}
									dataqa="continue-forgot-username"
									disabled={clean}
								/>
							</div>
							<div className="row-container centered">
								<WrappedButton
									label="Cancel"
									buttonType={WrappedButtonType.TertiaryGhost}
									dataqa="cancel-forgot-password"
									onClick={this.goToSignInView}
								/>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withLayoutAndModalContexts(ForgotUsername);
